import React, { useEffect, useState } from 'react';

// Lightweight toasts. Call toast('One away!') or toast(message, { error: true })
// from anywhere; <ToastHost /> is mounted once in App.js. Use these instead of alert().
const listeners = new Set();
let nextId = 1;

export function toast(message, { error = false, duration = 2400 } = {}) {
  const item = { id: nextId++, message: String(message), error, duration };
  listeners.forEach((fn) => fn(item));
}

export function ToastHost() {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const add = (item) => {
      setItems((list) => [...list.slice(-2), item]);
      setTimeout(() => setItems((list) => list.filter((i) => i.id !== item.id)), item.duration);
    };
    listeners.add(add);
    return () => listeners.delete(add);
  }, []);

  return (
    <div className="cr-toasts" role="status" aria-live="polite">
      {items.map((i) => (
        <div key={i.id} className={`cr-toast${i.error ? ' error' : ''}`} style={{ animationDuration: `${i.duration}ms` }}>
          {i.message}
        </div>
      ))}
    </div>
  );
}
